import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface OrderUpdateStatusParams {
	orderId: string;
	statusId: number;
}

export interface OrderUpdateStatusCommandResult {
}

export class OrderUpdateStatusCommand extends Command<OrderUpdateStatusParams, OrderUpdateStatusCommandResult> { }

export class OrderUpdateStatusCommandBase implements CommandHandler<OrderUpdateStatusCommand, OrderUpdateStatusParams, OrderUpdateStatusCommandResult> {
	private static Url = TaggedUrl.join('orders/:orderId/status/:statusId', [Tags.SelloApi]);

	public constructor(
		private readonly http: HttpService
	) { }

	public async handleAsync(command: OrderUpdateStatusCommand): Promise<OrderUpdateStatusCommandResult> {
		const url = fillPlaceholders(OrderUpdateStatusCommandBase.Url, { statusId: command.params?.statusId, orderId: command.params?.orderId });
		const { data } = await this.http.post<OrderUpdateStatusCommandResult>(url);
		return data;
	}
}
